<template>
      <div class="box">
        <h1>受影响机构安全风险监测</h1>
        <div class="content">
          <div class="contentIn">
            <div class="left">
              <p>{{first.name}}</p>
            </div>
            <div class="rightFirst">
              <div class="rightImg">
                <img src="@/assets/newTheatre/qianlan.png" alt="">
              </div>
              <h3>{{first.count}}</h3>
            </div>
          </div>
          <div class="contentIn">
            <div class="left">
              <p>{{second.name}}</p>
            </div>
            <div class="right">
              <div class="rightImg">
                <img src="@/assets/newTheatre/blue.png" alt="">
              </div>
              <h3>{{second.count}}</h3>
            </div>
          </div>
          <div class="contentIn">
            <div class="left">
              <p>{{third.name}}</p>
            </div>
            <div class="right">
              <div class="rightImg">
                <img src="@/assets/newTheatre/green.png" alt="">
              </div>
              <h3>{{third.count}}</h3>
            </div>
          </div>
        </div>
      </div>
</template>
<style scoped lang="less">
.box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  position: relative;
  color: rgba(255, 255, 255, 1);
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  position: absolute;
  left: 36px;
  top: 15px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
}

.content{
  position: absolute;
  left: 36px;
  top: 46px;
  padding-top: 30px;
}

.contentIn{
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  .left{
    width: 78px;
    font-size: 12px;
    height: 18px;
    background: url("../../assets/newTheatre/titleBackground.png") no-repeat;
    background-size: 100%;
    margin-right: 20px;
  }
  .right{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    font-family: 'YouSheBiaoTiHei';
    .rightImg{
      height: 30px;
      width: 100%;
      img{
        height: 30px;
      }
    }
    h3{
      margin-left: 10px;
      font-size: 14px;
    }
  }
  .rightFirst{
    position: relative;
    width: 300px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    font-family: 'YouSheBiaoTiHei';
    .rightImg{
      position: absolute;
      left: 0;
      height: 30px;
      width: 217px;
      img{
        width: 100%;
      }
    }
    h3{
      position: absolute;
      left: 76%;
      font-size: 14px;
    }
  }
}
</style>
<script>
import {getAffectedFacilities} from "@/service/dashboard";
import store from "@/store";

export default {
  data() {
    return {
      first: {name: "CN", count: 0},
      second: {name: "CN", count: 0},
      third: {name: "CN", count: 0}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getAffectedFacilities().then(res => {
        if (res[store.state.dict.threatId]) {
          const origin = res[store.state.dict.threatId].sort((a,b) => b.count - a.count);

          this.first = origin[0];
          this.second = origin[1];
          this.third = origin[2];
        }
      });
    }
  }
};
</script>